import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../App';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        MK<span>Classes</span>
      </Link>

      <div className="navbar-links">
        {user ? (
          <>
            <Link to="/hub" className="navbar-link">Study Hub</Link>
            {user.role === 'admin' && (
              <Link to="/admin" className="navbar-link">Admin Panel</Link>
            )}
            <Link to="/profile" className="navbar-link">{user.name.split(' ')[0]}</Link>
            <button className="btn-nav-logout" onClick={handleLogout}>Logout</button>
          </>
        ) : (
          <>
            <Link to="/login">
              <button className="btn-nav-login">Log in</button>
            </Link>
            <Link to="/register">
              <button className="btn-nav-signup">Sign up</button>
            </Link>
          </>
        )}
      </div>
    </nav>
  );
}
